// hooks/useLandingPath.ts
/**
 * Resolves the active account's landing destination to a concrete visible leaf
 * route, reactive to the account's landingSection + menu visibility config.
 *
 * Used by LandingRedirect (the `/` index route) and anywhere a "home" target is
 * needed. Pure logic lives in utils/landingPath.ts (resolveLandingPath) so it is
 * unit-testable without React.
 */

import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
import { useMenuVisibility } from "@/hooks/useMenuVisibility";
import { resolveLandingPath } from "@/utils/landingPath";

export function useLandingPath(): string {
  const { activeAccount } = useAuth();
  const { isMenuVisible, isSubmenuVisible } = useMenuVisibility();
  const landingSection = activeAccount?.landingSection ?? null;

  return useMemo(
    () => resolveLandingPath(landingSection, isMenuVisible, isSubmenuVisible),
    [landingSection, isMenuVisible, isSubmenuVisible]
  );
}
